import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=8270d7a8&"
import script from "./IconDownload.vue?vue&type=script&lang=js&"
export * from "./IconDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports